"use client"
import { motion } from "framer-motion"

const Logo = () => {
  return (
    <motion.div
      className="w-24 h-24 mx-auto mb-8 bg-indigo-600 rounded-xl shadow-lg flex items-center justify-center"
      whileHover={{ scale: 1.1, rotate: 5 }}
      whileTap={{ scale: 0.9 }}
    >
      <span className="text-4xl font-bold text-white">GT</span>
    </motion.div>
  )
}

export default Logo

